import { SearchController } from "./controllers/SearchController";

document.addEventListener('DOMContentLoaded', () => {
  new SearchController();
});
